module.exports = __webpack_public_path__ + "img/32014.55f30924.png";